<template>
  <Button
    variant="outline"
    padding="none"
    class="p-3.5 md:py-3 md:px-4 gap-1.5"
  >
    <FilterFunnel class="w-5 h-5" />
    <slot>
      <span class="hidden md:block text-base/tight font-semibold md:px-0.5">{{
        t("components.buttons.filter")
      }}</span>
    </slot>
  </Button>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { Button } from "@/Shadcn/Components/ui/button";
import { FilterFunnel } from "@/Icons";

const { t } = useI18n();
</script>
